 var handle = window.productHandle;

const KonfigTracking = (() => {

  // ── KONFIGURATION ─────────────────────────────────────────
  const WP_URL  = 'https://dashboard.mirrored.pro/';
  const API_KEY = 'testkey';
  const KONFIG  = handle; // ← pro Kunde anpassen
  const USER_ID = 6;            // ← WP User ID des Kunden

  // ── SESSION STATE ─────────────────────────────────────────
  const SESSION_ID    = 'sess-' + Math.random().toString(36).substr(2, 9);
  const SESSION_START = { time: null };
  let   _endFired     = false; // doppeltes Feuern verhindern

  // ── DEVICE ────────────────────────────────────────────────
  function getDevice() {
    const ua = navigator.userAgent;
    if (/iPhone|iPad|iPod/.test(ua)) return 'ios';
    if (/Android/.test(ua)) return 'android';
    return 'desktop';
  }

  // ── SEND ──────────────────────────────────────────────────
  function send(element_key, event_type, duration_ms = 0, cart_value = 0) {
    const payload = JSON.stringify({
      user_id:      USER_ID,
      konfigurator: KONFIG,
      element_key,
      event_type,
      duration_ms,
      cart_value,
      device:       getDevice(),
      page_url:     window.location.href,
      session_id:   SESSION_ID,
    });

    // fetch primär
    fetch(`${WP_URL}/wp-json/konfig/v1/track`, {
      method:  'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Konfig-Key': API_KEY,
      },
      body: payload,
    }).catch(() => {
      // Fallback: sendBeacon wenn fetch fehlschlägt
      navigator.sendBeacon(
        `${WP_URL}/wp-json/konfig/v1/track`,
        new Blob([payload], { type: 'application/json' })
      );
    });
  }

  // ── END SESSION ───────────────────────────────────────────
  function endSession() {
    // Doppeltes Feuern verhindern
    if (!SESSION_START.time || _endFired) return;
    _endFired = true;

    const duration_ms = Date.now() - SESSION_START.time;
    SESSION_START.time = null;

    const payload = JSON.stringify({
      user_id:      USER_ID,
      konfigurator: KONFIG,
      element_key:  'session:close',
      event_type:   'dwell',
      duration_ms:  duration_ms,
      cart_value:   0,
      device:       getDevice(),
      page_url:     window.location.href,
      session_id:   SESSION_ID,
    });

    // fetch primär
    fetch(`${WP_URL}/wp-json/konfig/v1/track`, {
      method:  'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Konfig-Key': API_KEY,
      },
      body: payload,
    }).catch(() => {
      // Fallback: sendBeacon
      navigator.sendBeacon(
        `${WP_URL}/wp-json/konfig/v1/track`,
        new Blob([payload], { type: 'application/json' })
      );
    });
  }

  // ── INIT ──────────────────────────────────────────────────
  function init() {
    SESSION_START.time = Date.now();
    _endFired          = false; // Reset falls init() erneut aufgerufen wird
    send('session:start', 'click');

    // Methode 1: Tab/Browser schließen, URL wechseln
    window.addEventListener('beforeunload', endSession, { once: true });

    // Methode 2: Tab wechseln, App minimieren (iOS zuverlässig)
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        endSession();
      }
    }, { once: true });
  }

  // ── TRACK CLICK ───────────────────────────────────────────
  function track(category, value, cartValue = 0) {
    const element_key = ['addcart', 'ar:start', 'session:close'].includes(category)
      ? category
      : `${category}:${value}`;
    send(element_key, 'click', 0, cartValue);
  }

  // ── TRACK DWELL ───────────────────────────────────────────
  function trackDwell(category, value, startTime) {
    const ms = Date.now() - startTime;
    if (ms < 500) return; // unter 0.5s ignorieren
    send(`${category}:${value}`, 'dwell', ms);
  }

  // ── EXPORT ────────────────────────────────────────────────
  return { init, track, trackDwell, endSession };

})();



(function(){

  // nur dieses Modal auswählen
  var root = document.querySelector('[data-clx-gallery="3"]');
  if(!root) return;

  var dialog = root.querySelector('[data-dialog="3"]');
  var closeBtn = root.querySelector('[data-close="3"]');

  //var open3dmod = document.querySelector('a[href*="#show3d"]');

  var open3dmod = document.getElementById("open3d");


  // --- OPEN ---
  open3dmod.addEventListener('click', open3d);


  function open3d(){
     KonfigTracking.init();
    if(dialog && typeof dialog.showModal === "function"){

     //iframe src =   {{product.metafields.custom.modell}}

      setTimeout(() => dialog.showModal(), 400);

    } else {
      dialog.setAttribute('open','open');
    }
  };

  // --- CLOSE ---
  function closeModal(){
    if(dialog && dialog.open){
      dialog.close();
        KonfigTracking.endSession();
    }
  }

  if(closeBtn){
    closeBtn.addEventListener('click', closeModal);
  }

/*
  // Klick außerhalb
  dialog.addEventListener('click', function(e){
    var rect = dialog.getBoundingClientRect();
    var inside =
      e.clientX >= rect.left &&
      e.clientX <= rect.right &&
      e.clientY >= rect.top &&
      e.clientY <= rect.bottom;

    if(!inside) closeModal();
  });
*/
  // Escape
  dialog.addEventListener('keydown', function(e){
    if(e.key === 'Escape'){
      closeModal();
    }
  });

})();


const modelViewerVariants = document.querySelector("model-viewer#framebag");
        const colorW = document.querySelector('#colW');
        const colorB = document.querySelector('#colB');
        const startAR = document.getElementById("toggle");
        const closeInfo =  document.getElementById("closeqr");
        const startMobileAr = document.getElementById("launchAR");

 colorW.addEventListener('click', (event) => {
          modelViewerVariants.variantName = event.target.value === 'default' ? null : event.target.value;
          KonfigTracking.track('Farbe', 'Light Grey');
        });

        colorB.addEventListener('click', (event) => {
          modelViewerVariants.variantName = event.target.value === 'default' ? null : event.target.value;
             KonfigTracking.track('Farbe', 'Black');
        });

         startAR.addEventListener('click', (event) => {
          //text.style.display= "none";
          //document.getElementById("ctrl").display="none";
          //modelViewerVariants.activateAR(); 

          console.log("click");
             KonfigTracking.track('ar:start', 'ar:start');
        document.getElementById("qr").style.display="flex";
                document.getElementById("clx-content3d").style.display="none"

        });

         closeInfo.addEventListener('click', (event) => {
   
          console.log("click");

        document.getElementById("qr").style.display="none";
                document.getElementById("clx-content3d").style.display="block"

        });

           startMobileAr.addEventListener('click', (event) => {
       document.getElementById("clx-content3d").style.display="block"
        document.getElementById("qr").style.display="none";
          modelViewerVariants.activateAR(); 
           });
